/*
 * Module for handling individual substitution category
 */

define([
  "marionette",
  "messaging/messenger",
  "./categoryView",
  "./categoryValues/categoryValuesModule",
  "./categoryInfo/categoryInfoModule",
  "modules/shared/sortableList/sortableListModule",
], function (Marionette, Messenger, CategoryView, CategoryValuesModule, CategoryInfoModule) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "category";
      this.region = options.region;
      this.category = null;
      this._setUpVents();
    },
    show: function (category) {
      console.log("show");
      this.layout = new CategoryView.categoryLayout();
      this.category = category;
      //if validation fails, call the appropriate functions to display the error
      this.category.on(
        "invalid",
        function (model, error) {
          if ("categoryName" in error) {
            Messenger.vent.trigger("cancel:textbox"); //cancel any open textboxes
            this.categoryInfo.nameError(error["categoryName"]);
          }
        },
        this,
      );

      //listen for a change to the subGroup name
      //if the group is new and empty, then add an entry to the group with the same name as the group and set
      //it to auto apply
      //      if (this.category.isNew()){
      //        this.category.once("enter:name", function(){
      //          var entries = this.subGroup.entries();
      //          if (entries.length === 0) {
      //            //add an entry
      //            var newEntry = entries.addNewEntry();
      //            newEntry.set("entrySurfaceForm", this.subGroup.get("name"));
      //            newEntry.set("defaultEntry", true);
      //          }
      //        }, this);
      //      }

      this.categoryInfo = this.addSubModule(
        new CategoryInfoModule({ region: this.layout.categoryInfo, model: category }),
      );
      this.categoryValues = this.addSubModule(
        new CategoryValuesModule({ region: this.layout.categoryValues }),
      );

      this.layout.on(
        "show",
        function () {
          this._showSubViews(category);
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _showSubViews: function (category) {
      this.categoryInfo.show();
      this.categoryValues.show(category.getValues());
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "category:selected",
        function (category) {
          this.show(category);
        },
        this,
      );

      Messenger.vent.on(
        "delete:category",
        function () {
          //reset region view
          this.region.reset();
          this.category = null; //disconnect category from module
        },
        this,
      );
    },
  });
});
